export default __webpack_public_path__ + "static/media/bookworldlistad.126210b1d80673af5eaf3bca56f41281.webp";